// extracted by mini-css-extract-plugin
export default {"loadingScreen":"App_loadingScreen__L4C2s"};